import type { Logger as DataDogLogger } from '@datadog/browser-logs';

import { AbstractLogger } from './AbstractLogger';
import type { DataDogConfig, LogContext, Team } from '../types';
import { createLogger, initDataDog, refreshContext } from '../utils/datadog';

export class HttpLogger extends AbstractLogger {
  private _httpLogger: DataDogLogger;

  public constructor(config: DataDogConfig, context: LogContext) {
    super();

    initDataDog(config, context);

    const {
      handler: { level, name, type },
    } = config;

    this._httpLogger = createLogger(name, type, level);
  }

  public refreshContext(context: LogContext): void {
    refreshContext(context);
  }

  public log<OptionalParams>(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<OptionalParams>
  ): void {
    this._httpLogger.log(message, { teams, ...optionalParams });
  }

  public info<OptionalParams>(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<OptionalParams>
  ): void {
    this._httpLogger.info(message, { teams, ...optionalParams });
  }

  public error<OptionalParams>(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<OptionalParams>
  ): void {
    this._httpLogger.error(message, { teams, ...optionalParams });
  }

  public success<OptionalParams>(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<OptionalParams>
  ): void {
    // DataDog doesn't implement the success method, so we replace it with info.
    this._httpLogger.info(message, { teams, ...optionalParams });
  }
}
